const resources = {
    title: 'Essayez le Balayage de la peau intelligent',
    subtitle: 'Bénéficiez de recommandations beauté en quelques secondes grâce à notre outil basé sur l’IA.',
    tryNow: 'Essayer'
};

export default function getResource(label) {
    return resources[label];
}
